import { useState } from "react";
import { Heart, HeartCrack } from "lucide-react"; // HeartCrack works as a half/empty indicator

export default function Hearts({ lovemeter, isSpecial = false }) {
  const [likes] = useState(lovemeter);

  const percentage = likes / 3000;
  const fullHearts = Math.floor(percentage * 3);
  const halfHearts = Math.round((percentage * 3 - fullHearts) * 2);

  const hearts = [];
  const heartColor = isSpecial ? "fill-white stroke-white" : "fill-red-400 stroke-red-400";
  const emptyHeartColor = isSpecial ? "stroke-white" : "stroke-red-400";

  // Full hearts
  for (let i = 0; i < fullHearts; i++) {
    hearts.push(
      <Heart
        key={`full-${i}`}
        className={`w-3.5 h-3.5 ${heartColor}`}
      />
    );
  }

  // Half hearts (Lucide has no half-heart, so we can use HeartCrack)
  if (halfHearts > 0) {
    hearts.push(
      <HeartCrack
        key="half"
        className={`w-3.5 h-3.5 ${heartColor}`}
      />
    );
  }

  // Empty hearts (optional)
  const empty = 3 - (fullHearts + (halfHearts > 0 ? 1 : 0));
  for (let i = 0; i < empty; i++) {
    hearts.push(
      <Heart
        key={`empty-${i}`}
        className={`w-3.5 h-3.5 ${emptyHeartColor}`}
      />
    );
  }

  return <div className="flex gap-1">{hearts}</div>;
}
